// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderComp_loaderWrapper__UI-1D","cubeWrapper":"LoaderComp_cubeWrapper__J+vWq","cube":"LoaderComp_cube__9UBIN","rotateCube":"LoaderComp_rotateCube__W1e5o"};